import { t } from '@procumi/shared';
import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
// limba întâi: constantele cu texte din ecrane se calculează la încărcare
import './lib/i18n';
import App from './App';
import './styles/tokens.css';
import './styles/global.css';
import './styles/premium.css';
import './styles/v3.css';

const el = document.getElementById('root');
if (!el) throw new Error(t('Lipsește #root din index.html'));

/** `/consola`: consola echipei Procumi, încărcată separat (clienții nu o descarcă). */
const ConsoleApp = lazy(() => import('./console/ConsoleApp').then((m) => ({ default: m.ConsoleApp })));
const isConsole = window.location.pathname.replace(/\/+$/, '') === '/consola';

createRoot(el).render(
  <StrictMode>
    {isConsole ? (
      <Suspense fallback={null}>
        <ConsoleApp />
      </Suspense>
    ) : (
      <App />
    )}
  </StrictMode>,
);
